// ===== Work Board — manual registration sheet =====
// 머리 "업무 등록" 버튼이 여는 우측 시트(업무 상세 시트와 같은 골격·같은 폭 손잡이, 2026-10-04 통일). classic script로 board.js와 같은 전역을
// 공유한다(_boardDom/_boardFetchJson/_boardLoadBoard/_boardSetStatus 등은 board.ts 소유).
// POST /api/work/items (owner는 서버가 인증 actor로 세팅). 상위 업무를 고르면 하위 업무로 등록된다(깊이 1은 서버가 검사).

// 제출 전 협업자 후보를 임시로 들고 있는다.
var _boardRegisterState: { collaborators: BoardRegisterCollaborator[] } = { collaborators: [] };
var _boardRegisterDom: {
  form: HTMLFormElement;
  title: HTMLInputElement;
  summary: HTMLTextAreaElement;
  priority: HTMLSelectElement;
  lane: HTMLSelectElement;
  due: HTMLInputElement;
  parent: HTMLSelectElement;
  project: HTMLSelectElement;
  collabSelect: HTMLSelectElement;
  collabList: HTMLElement;
  error: HTMLElement;
};

function _boardInitRegisterForm() {
  // 업무 상세 시트와 같은 골격: 머리(종류·제목·닫기) · 본문(왼쪽 라벨 76px + 칸, 상세와 같은 속성 줄) · 바닥(취소·등록).
  const sheet = document.getElementById("work-register-sheet") || _boardDom.registerFormRoot;
  sheet.insertAdjacentHTML("beforeend", `
    <form id="work-register-form" class="work-sheet-form" novalidate>
      <div class="ax-detail-sidepanel-header work-sheet-header">
        <div class="ax-detail-sidepanel-titlegroup">
          <div class="ax-detail-sidepanel-type">새 업무</div>
          <h2 id="work-register-heading" class="work-sheet-title">업무 등록</h2>
        </div>
        <button type="button" class="ui-btn ax-button ax-button--ghost ax-detail-sidepanel-close" id="work-register-close-btn" aria-label="업무 등록 닫기">닫기</button>
      </div>
      <div class="ax-detail-sidepanel-body work-sheet-body">
        <label class="work-detail-visually-hidden" for="work-register-title">제목</label>
        <input type="text" id="work-register-title" class="work-detail-title-input work-sheet-title-input" maxlength="300" placeholder="업무 제목" required>
        <dl class="work-detail-props work-sheet-props">
          <div class="work-detail-prop">
            <dt><label for="work-register-priority">우선순위</label></dt>
            <dd><select id="work-register-priority" class="work-detail-control">
              <option value="low">낮음</option>
              <option value="medium" selected>보통</option>
              <option value="high">높음</option>
              <option value="critical">긴급</option>
            </select></dd>
          </div>
          <div class="work-detail-prop">
            <dt><label for="work-register-lane">처음 상태</label></dt>
            <dd><select id="work-register-lane" class="work-detail-control">
              <option value="backlog">백로그</option>
              <option value="planned" selected>계획</option>
              <option value="in_progress">진행 중</option>
            </select></dd>
          </div>
          <div class="work-detail-prop">
            <dt><label for="work-register-due">마감</label></dt>
            <dd><input type="date" id="work-register-due" class="work-detail-control"></dd>
          </div>
          <div class="work-detail-prop">
            <dt><label for="work-register-project">프로젝트</label></dt>
            <dd><select id="work-register-project" class="work-detail-control"><option value="">없음</option></select></dd>
          </div>
          <div class="work-detail-prop">
            <dt><label for="work-register-parent">상위 업무</label></dt>
            <dd><select id="work-register-parent" class="work-detail-control"><option value="">없음(새 업무)</option></select></dd>
          </div>
          <div class="work-detail-prop">
            <dt><label for="work-register-collab-select">협업자</label></dt>
            <dd><div class="work-detail-people">
              <div class="work-register-collab-list" id="work-register-collab-list"></div>
              <select id="work-register-collab-select" class="work-detail-control">
                <option value="">팀원 선택…</option>
              </select>
            </div></dd>
          </div>
        </dl>
        <section class="work-detail-section">
          <h3 class="work-detail-section-title"><label for="work-register-summary">설명 <span class="work-register-hint">· 선택</span></label></h3>
          <textarea id="work-register-summary" class="work-detail-summary" rows="3" placeholder="업무 내용을 적어 두세요"></textarea>
        </section>
        <div class="work-register-error" id="work-register-error" role="alert" hidden></div>
      </div>
      <div class="work-sheet-footer">
        <button type="button" class="ui-btn ax-button ax-button--ghost" id="work-register-cancel-btn">취소</button>
        <button class="ui-btn ax-button ax-button--primary" type="submit">등록</button>
      </div>
    </form>
  `);
  _boardAttachSheetResizer(sheet.querySelector<HTMLElement>(".work-sheet-resizer"));

  _boardRegisterDom = {
    form: _boardRequireElement<HTMLFormElement>("work-register-form"),
    title: _boardRequireElement<HTMLInputElement>("work-register-title"),
    summary: _boardRequireElement<HTMLTextAreaElement>("work-register-summary"),
    priority: _boardRequireElement<HTMLSelectElement>("work-register-priority"),
    lane: _boardRequireElement<HTMLSelectElement>("work-register-lane"),
    due: _boardRequireElement<HTMLInputElement>("work-register-due"),
    parent: _boardRequireElement<HTMLSelectElement>("work-register-parent"),
    project: _boardRequireElement<HTMLSelectElement>("work-register-project"),
    collabSelect: _boardRequireElement<HTMLSelectElement>("work-register-collab-select"),
    collabList: _boardRequireElement("work-register-collab-list"),
    error: _boardRequireElement("work-register-error"),
  };

  _boardDom.registerBtn.addEventListener("click", () => _boardToggleRegisterForm());
  _boardRequireElement<HTMLButtonElement>("work-register-close-btn").addEventListener("click", _boardCloseRegisterForm);
  _boardRequireElement<HTMLButtonElement>("work-register-cancel-btn").addEventListener("click", _boardCloseRegisterForm);
  _boardDom.registerBackdrop.addEventListener("click", _boardCloseRegisterForm);
  _boardRegisterDom.collabSelect.addEventListener("change", _boardAddRegisterCollaborator);
  _boardRegisterDom.project.addEventListener("change", () => _boardPopulateParentOptions(_boardRegisterDom.parent.value || undefined));
  // 프로젝트·상위 업무는 검색 드롭다운(core/search-select.ts). 값의 주인은 그대로 이 select 들이다.
  if (typeof SearchSelect !== "undefined") {
    SearchSelect.attach(_boardRegisterDom.project, { searchPlaceholder: "프로젝트 검색", emptyText: "맞는 프로젝트가 없어요." });
    SearchSelect.attach(_boardRegisterDom.parent, { searchPlaceholder: "업무 제목·프로젝트·담당으로 검색", emptyText: "맞는 업무가 없어요." });
  }
  _boardRegisterDom.form.addEventListener("submit", _boardSubmitRegisterForm);
  // Esc 는 시트 어디서든(폼 칸·폭 조절 손잡이) 닫는다.
  _boardDom.registerFormRoot.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key === "Escape") { event.stopPropagation(); _boardCloseRegisterForm(); }
  });
  void _boardPopulateCollaboratorOptions();
}

// 협업자 후보를 팀원 목록(GET /api/rooms/actors)으로 채운다. 내부 slug를 직접 타이핑하지 않고 사람 이름으로 고른다.
async function _boardPopulateCollaboratorOptions() {
  const select = _boardRegisterDom.collabSelect;
  const people = await _boardLoadPeople();
  people.forEach(person => {
    if (person.isSelf || !person.actorId.startsWith("user:")) return;
    const option = document.createElement("option");
    option.value = person.actorId;
    option.textContent = person.label;
    select.appendChild(option);
  });
}

// 상위 업무 후보: 끝나지 않은 최상위 업무(하위 업무는 하위를 가질 수 없다). 지금 보드 필터(범위·프로젝트·카드 필터)와 상관없이
// 팀 전체(allCards)에 지금 보드 카드(개인 범위 포함)를 합친다 — 필터에 걸린 업무가 상위 후보에서 조용히 빠지지 않게(2026-10-05).
// 줄 오른쪽 보조 글 = "프로젝트 · 담당"(검색도 이 글까지 본다). 프로젝트를 골라 두면 "이 프로젝트" 묶음을 위에 둔다.
function _boardParentCandidates(): BoardCard[] {
  const seen = new Set<string>();
  const out: BoardCard[] = [];
  [...(_boardState.allCards || []), ..._boardLaneCards()].forEach(card => {
    if (card.parentId || seen.has(card.id) || card.status === "done" || card.status === "cancelled") return;
    seen.add(card.id);
    out.push(card);
  });
  return out;
}

function _boardParentOption(card: BoardCard): HTMLOptionElement {
  const option = document.createElement("option");
  option.value = card.id;
  option.textContent = card.title || card.id;
  const project = _boardEffectiveProject(card);
  option.dataset.meta = [project && project.title ? project.title : "프로젝트 없음", _boardFormatOwner(card.owner)].join(" · ");
  return option;
}

function _boardPopulateParentOptions(selectedParentId?: string) {
  const select = _boardRegisterDom.parent;
  select.innerHTML = '<option value="">없음(새 업무)</option>';
  const candidates = _boardParentCandidates();
  const projectId = _boardRegisterDom.project.value;
  const mine = projectId ? candidates.filter(card => { const project = _boardEffectiveProject(card); return !!project && project.id === projectId; }) : [];
  if (mine.length) {
    const group = document.createElement("optgroup");
    group.label = "이 프로젝트";
    mine.forEach(card => group.appendChild(_boardParentOption(card)));
    const rest = document.createElement("optgroup");
    rest.label = "다른 업무";
    candidates.filter(card => !mine.includes(card)).forEach(card => rest.appendChild(_boardParentOption(card)));
    select.appendChild(group);
    if (rest.children.length) select.appendChild(rest);
  } else {
    candidates.forEach(card => select.appendChild(_boardParentOption(card)));
  }
  if (selectedParentId && !candidates.some(card => card.id === selectedParentId)) {
    const option = document.createElement("option");
    option.value = selectedParentId;
    option.textContent = _boardCardTitle(selectedParentId) || (_boardState.detail && _boardState.detail.item.id === selectedParentId ? _boardState.detail.item.title || "상위 업무" : "상위 업무");
    select.appendChild(option);
  }
  select.value = selectedParentId || "";
}

async function _boardPopulateRegisterProjects() {
  const select = _boardRegisterDom.project;
  const projects = await _boardLoadProjects();
  select.innerHTML = '<option value="">없음</option>';
  (projects || []).filter(project => project.status !== "done").forEach(project => {
    const option = document.createElement("option");
    option.value = project.id;
    option.textContent = project.name;
    select.appendChild(option);
  });
  select.disabled = !projects || projects.length === 0;
  // 팀 보드에서 프로젝트를 골라 둔 채 등록하면 그 프로젝트를 미리 고른다(바꿀 수 있다).
  const chosen = _boardState.projectFilter;
  if (chosen && Array.from(select.options).some(option => option.value === chosen)) select.value = chosen;
  // 고른 프로젝트에 맞춰 상위 업무의 "이 프로젝트" 묶음을 다시 짠다(고른 상위 업무는 그대로).
  _boardPopulateParentOptions(_boardRegisterDom.parent.value || undefined);
}

function _boardToggleRegisterForm(parentId?: string) {
  if (_boardDom.registerFormRoot.hidden) {
    _boardPopulateParentOptions(parentId);
    void _boardPopulateRegisterProjects();
    _boardOpenSheet(_boardDom.registerFormRoot);
    _boardDom.registerBtn.setAttribute("aria-expanded", "true");
    _boardRegisterDom.title.focus();
  } else {
    _boardCloseRegisterForm();
  }
}

function _boardCloseRegisterForm() {
  _boardCloseSheet(_boardDom.registerFormRoot);
  _boardDom.registerBtn.setAttribute("aria-expanded", "false");
  _boardRegisterDom.form.reset();
  _boardRegisterState.collaborators = [];
  _boardRenderRegisterCollaborators();
  _boardSetRegisterError("");
}

function _boardSetRegisterError(message: string) {
  _boardRegisterDom.error.textContent = message;
  _boardRegisterDom.error.hidden = !message;
}

// 협업자 후보는 제출 전 이름표만 화면에 보여준다 — textContent 바인딩으로 악성 입력을 inert 처리한다.
function _boardRenderRegisterCollaborators() {
  const host = _boardRegisterDom.collabList;
  host.textContent = "";
  _boardRegisterState.collaborators.forEach((collaborator, index) => {
    const chip = document.createElement("span");
    chip.className = "person-chip";
    const avatar = document.createElement("span");
    avatar.className = "person-av";
    avatar.setAttribute("aria-hidden", "true");
    avatar.setAttribute("data-hue", String(_boardHueFor(collaborator.actorId || collaborator.label)));
    avatar.textContent = _boardPersonInitial(collaborator.label);
    const text = document.createElement("span");
    text.textContent = collaborator.label;
    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "person-chip-remove";
    removeBtn.setAttribute("aria-label", `${collaborator.label} 제거`);
    removeBtn.textContent = "✕";
    removeBtn.addEventListener("click", () => {
      _boardRegisterState.collaborators.splice(index, 1);
      _boardRenderRegisterCollaborators();
    });
    chip.append(avatar, text, removeBtn);
    host.appendChild(chip);
  });
}

function _boardAddRegisterCollaborator() {
  const select = _boardRegisterDom.collabSelect;
  const actorId = select.value.trim();
  if (!actorId) return;
  const label = (select.options[select.selectedIndex]?.textContent || "").trim() || actorId;
  if (!_boardRegisterState.collaborators.some(collaborator => collaborator.actorId === actorId)) {
    _boardRegisterState.collaborators.push({ actorId, label });
  }
  select.value = "";
  _boardRenderRegisterCollaborators();
}

async function _boardSubmitRegisterForm(event: SubmitEvent) {
  event.preventDefault();
  const title = _boardRegisterDom.title.value.trim();
  if (!title) {
    _boardSetRegisterError("제목을 입력해 주세요.");
    _boardRegisterDom.title.focus();
    return;
  }

  const submitBtn = _boardRegisterDom.form.querySelector<HTMLButtonElement>("[type=submit]");
  if (submitBtn) submitBtn.disabled = true;
  _boardSetRegisterError("");

  const summary = _boardRegisterDom.summary.value.trim();
  const dueIso = _boardRegisterDom.due.value ? _boardDateToIso(_boardRegisterDom.due.value, null) : null;
  const parentId = _boardRegisterDom.parent.value;
  const projectId = _boardRegisterDom.project.value;

  const body: BoardJson = { title, priority: _boardRegisterDom.priority.value, status: _boardRegisterDom.lane.value };
  if (summary) body.summary = summary;
  if (_boardRegisterState.collaborators.length) body.collaborators = _boardRegisterState.collaborators;
  if (dueIso) body.time = { dueAt: dueIso };
  if (parentId) body.parentId = parentId;
  if (projectId) body.projectId = projectId;

  try {
    await _boardFetchJson("/api/work/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    _boardCloseRegisterForm();
    await _boardLoadBoard({ preserveSelection: false });
    if (parentId && _boardState.selectedItemId === parentId) await _boardLoadDetail(parentId).catch(() => undefined);
    _boardSetStatus("success", "업무를 등록했습니다.", { toast: true });
  } catch (error) {
    if (_boardErrorCode(error) === "project_deleted") {
      _boardSetRegisterError(_boardProjectDeletedText(error));
      // 프로젝트 목록을 다시 읽어 지워진 프로젝트를 고를 수 없게 한다(다른 입력은 그대로).
      _boardForgetProjects();
      await _boardPopulateRegisterProjects();
      if (typeof workProjectsRefresh === "function") void workProjectsRefresh();
      _boardRegisterDom.project.focus();
    } else {
      _boardSetRegisterError(error instanceof Error ? error.message : "업무 등록에 실패했습니다.");
    }
  } finally {
    if (submitBtn) submitBtn.disabled = false;
  }
}
